require('./hirePackOpenYoungView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const blockedAccountsActions = require('actions/blockedAccounts');
const hirePackOpenYoungActions = require('actions/hirePackOpenYoung');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const profileActions = require('actions/profile');
const shippingAddressAction = require('actions/shippingAddress');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const HirePackOpenYoungStep1 = require('components/hire/packOpenYoung/hirePackOpenYoungStep1/hirePackOpenYoungStep1');
const HirePackOpenYoungStep2 = require('components/hire/packOpenYoung/hirePackOpenYoungStep2/hirePackOpenYoungStep2');
const HirePackOpenYoungStep3 = require('components/hire/packOpenYoung/hirePackOpenYoungStep3/hirePackOpenYoungStep3');
const HirePackOpenYoungStep4 = require('components/hire/packOpenYoung/hirePackOpenYoungStep4/hirePackOpenYoungStep4');
const HirePackOpenYoungStep5 = require('components/hire/packOpenYoung/hirePackOpenYoungStep5/hirePackOpenYoungStep5');
const HirePackOpenYoungStep6 = require('components/hire/packOpenYoung/hirePackOpenYoungStep6/hirePackOpenYoungStep6');
const HirePackOpenYoungSuccess = require('components/hire/packOpenYoung/hirePackOpenYoungSuccess/hirePackOpenYoungSuccess');
const HirePackOpenYoungError = require('components/hire/packOpenYoung/hirePackOpenYoungError/hirePackOpenYoungError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

// @constants
const {
    OPENYOUNG_ACCOUNT_SUBTYPE,
    OPENYOUNG_ACCOUNT_TYPE,
    OPENYOUNG_CARD_STANDARD,
    OPENYOUNG_CARD_SUBTYPE,
    OPENYOUNG_CARD_TYPE,
    REDIRECT_URL,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
    OPEN_YOUNG_PACK_KEY,
} = require('constants/index');
const { HIRE_CARD_OPEN_YOUNG_PACK } = require('constants/operationCodesAccounts');
const {
    PROC_CONTRACTS
} = require('utilities/tagging');
const { WEB_INACTIVE_ACCOUNT_ENABLED, OPEN_YOUNG_PACK, ES_COUNTRY, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('components/hire/packOpenYoung/analytics/hirePackOpenYoungAnalytics');

class HirePackOpenYoungView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

        if (!props.openYoungPack) {
            props.history.push('/myprofile/cards');
        }
    }

    componentDidMount() {
        const {
            getshippingAddressList,
            match: { params: { redirect } },
            validateStep,
            getBlockedAccounts,
            immAccounts,
            resetPrecontractualDocumentMail
        } = this.props;

        resetPrecontractualDocumentMail();
        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getshippingAddressList();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_OPEN_YOUNG_PACK);
    }

    componentWillUnmount() {
        const {
            reset,
            resetPrecontractualMail,
            resetBlockedAccounts,
            resetTermsAndCondsText,
        } = this.props;

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    getProcessDetail() {
        return `${OPENYOUNG_ACCOUNT_TYPE}.${OPENYOUNG_ACCOUNT_SUBTYPE} - ${OPENYOUNG_CARD_TYPE}.${OPENYOUNG_CARD_SUBTYPE}`;
    }

    handleCancel() {
        this.props.history.push('myprofile/global');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHirePackOpenYoung } = this.props;
        let showPreLeaveModal = true;

        if (immHirePackOpenYoung.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHirePackOpenYoung,
            immShippingAddressList,
            immHireOpenYoungInterveners,
            immOpenYoungPersonalData,
            immProfile
        } = this.props;
        const selectedAccount = immHirePackOpenYoung.getIn(['steps', THIRD_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HirePackOpenYoungSuccess
                    immAccount={immAccount}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireOpenYoungInterveners={immHireOpenYoungInterveners}
                    immHirePackOpenYoung={immHirePackOpenYoung}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    immOpenYoungPersonalData={immOpenYoungPersonalData}
                    immProfile={immProfile}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            handleTutorCheckboxChange,
            hirePackOpenYoung,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireContactData,
            immHireInformation,
            immHiringProductInformation,
            immHireOpenYoungInterveners,
            immHirePackOpenYoung,
            immOpenYoungPersonalData,
            immOpenYoungTaxData,
            immOpenYoungTutorType,
            immPdfData,
            immPreContractualMail,
            immProfile,
            immShippingAddressList,
            immHireCardImageIds,
            requestPDFMerge,
            requestProfile,
            sendPreContractualMail,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setShippingAddress,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            validate,
            validateStep,
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hirePackOpenYoung,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const sendMailParams = {
            account: {
                standar: OPENYOUNG_CARD_STANDARD,
                subType: OPENYOUNG_ACCOUNT_SUBTYPE,
                type: OPENYOUNG_ACCOUNT_TYPE,
            },
            card: {
                standar: OPENYOUNG_CARD_STANDARD,
                subType: OPENYOUNG_CARD_SUBTYPE,
                type: OPENYOUNG_CARD_TYPE,
            },

        };

        const showPreLeaveModal = this.isReady();
        const immSteps = immHirePackOpenYoung.get('steps');
        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.OPEN_YOUNG_PACK_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_PACK_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_PACK_STEP_3_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_PACK_STEP_4_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_PACK_STEP_5_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_PACK_STEP_6_VIEW]({ productName }),
        ];
        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        let hasShippingAddress = true;
        const operativeName = __CONTACT_CENTER__ ? "operatives-openYoungPack" : undefined;
        const printTitleValue = __CONTACT_CENTER__ && 'hirePackOpenYoung-operativeName';
        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHirePackOpenYoung.get('loadingFlag');
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        processType={PROC_CONTRACTS}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHirePackOpenYoung.get('visibleStep') - 1]}
                        visibleStep={immHirePackOpenYoung.get('visibleStep')}
                        wizardClass="hire-pack-open-young__wizard"
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            isLoading={loadingFlag}
                            cancelButton={true}
                            position="first"
                        >
                            <HirePackOpenYoungStep1
                                contractName="open-young"
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                gestorCrossEnabled={immFlagBasedFeatures.get('web-gc-enabled')}
                                hireCmsKey="Contratacion_PackOpenYoung_FichaProducto_slide1"
                                immHireInformation={immHireInformation}
                                immHiringProductInformation={immHiringProductInformation}
                                immHirePackOpenYoung={immHirePackOpenYoung}
                                immPreContractualMail={immPreContractualMail}
                                immProfileFields={immProfile}
                                requestPDFMerge={requestPDFMerge}
                                requestProfile={requestProfile}
                                sendMailParams={sendMailParams}
                                sendPreContractualMail={sendPreContractualMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            nextButtonDisabled={immHireCardImageSelector.get('isFetching')}
                            onBackClick={false}
                            position="middle"
                        >
                            <HirePackOpenYoungStep2
                                handleTutorCheckboxChange={handleTutorCheckboxChange}
                                immGlobalVariables={immGlobalVariables}
                                immHireContactData={immHireContactData}
                                immHirePackOpenYoung={immHirePackOpenYoung}
                                immOpenYoungPersonalData={immOpenYoungPersonalData}
                                immOpenYoungTaxData={immOpenYoungTaxData}
                                immOpenYoungTutorType={immOpenYoungTutorType}
                                validate={validate}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HirePackOpenYoungStep3
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immGlobalVariables={immGlobalVariables}
                                immHirePackOpenYoung={immHirePackOpenYoung}
                                immHireOpenYoungInterveners={immHireOpenYoungInterveners}
                                immOpenYoungPersonalData={immOpenYoungPersonalData}
                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                                validate={validate}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HirePackOpenYoungStep4
                                immHireCardImageIds={immHireCardImageIds}
                                immHireCardImageSelector={immHireCardImageSelector}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                            nextButtonDisabled={isShippingAddressButtonDisabled}
                        >
                            <HirePackOpenYoungStep5
                                immHireContactData={immHireContactData}
                                immShippingAddressList={immShippingAddressList}
                                setShippingAddress={setShippingAddress}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hirePackOpenYoung-hirePackOpenYoung_hire'}
                            isLoading={immHirePackOpenYoung.get('isFetching')}
                            onBackClick={false}
                            position="last"
                            SignaturePatternButton={SignaturePatternButton}
                        >
                            <HirePackOpenYoungStep6
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                immAccounts={immAccounts}
                                immHireOpenYoungInterveners={immHireOpenYoungInterveners}
                                immHirePackOpenYoung={immHirePackOpenYoung}
                                immOpenYoungPersonalData={immOpenYoungPersonalData}
                                immPdfData={immPdfData}
                                immProfile={immProfile}
                                immShippingAddress={immShippingAddressList.get('shippingAddress')}
                                operativeName={operativeName}
                                printTitleValue={printTitleValue}
                                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                    </Wizard>

                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immOpenYoungInterveners={immHireOpenYoungInterveners.get('list')}
                                immOpenYoungPersonalData={immOpenYoungPersonalData}
                                immProfile={immProfile}
                                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                                type={OPEN_YOUNG_PACK_KEY}
                                immAddress={immShippingAddress}
                                hasShippingAddress={hasShippingAddress}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHirePackOpenYoung, immFlagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hirePackOpenYoung-hirePackOpenYoung_pageTitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: formatText("hirePackOpenYoung-hirePackOpenYoung_breadcrumb")
            }
        ];
        const hireRestrictionFlag = immHirePackOpenYoung.getIn(['steps', WIZARD_FIRST_STEP-1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        const processDetail = this.getProcessDetail();

        let content;

        if (immHirePackOpenYoung.get('isFetchingScoring')) {
            content = <LoadingSection />;
        } else if (immHirePackOpenYoung.get('error')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HirePackOpenYoungError
                        immHirePackOpenYoung={immHirePackOpenYoung}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HirePackOpenYoungError
                        immHirePackOpenYoung={immHirePackOpenYoung}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        }
         else if (immHirePackOpenYoung.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-pack-open-young">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HirePackOpenYoungView.propTypes = {
    getBlockedAccounts: PropTypes.func,
    getshippingAddressList: PropTypes.func,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    handleTutorCheckboxChange: PropTypes.func.isRequired,
    hirePackOpenYoung: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immHireOpenYoungInterveners: PropTypes.object.isRequired,
    immHirePackOpenYoung: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immOpenYoungTaxData: PropTypes.object.isRequired,
    immOpenYoungTutorType: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    immPdfData: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    openYoungPack: PropTypes.bool.isRequired,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    immHireCardImageIds: PropTypes.object.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = HirePackOpenYoungView;
module.exports.HirePackOpenYoungView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireContactData: state.hireContactData,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immHireOpenYoungInterveners: state.hireOpenYoungInterveners,
        immHirePackOpenYoung: state.hirePackOpenYoung,
        immOpenYoungPersonalData: state.openYoungPersonalData,
        immOpenYoungTaxData: state.openYoungTaxData,
        immOpenYoungTutorType: state.openYoungTutorType,
        immPreContractualMail: state.preContractualMail,
        immHireCardImageIds: state.hireCardOpenYoung.get('hireCardImageIds'),
        immProfile: state.profile,
        immPdfData: state.precontractualsMergePdfs,
        immShippingAddressList: state.shippingAddress,
        openYoungPack: state.flagBasedFeatures.get(OPEN_YOUNG_PACK),
        isInactiveAccountsEnabled: state.flagBasedFeatures.get('web-inactive-account-enabled'),
    }),
    {
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        handleAccountChange: hirePackOpenYoungActions.setAccount,
        handleAgreementCheckboxChange: hirePackOpenYoungActions.setAgreementCheckbox,
        handleTutorCheckboxChange: hirePackOpenYoungActions.toggleTutorCheckbox,
        hirePackOpenYoung: hirePackOpenYoungActions.hirePackOpenYoung,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        requestProfile: profileActions.requestProfile,
        reset: hirePackOpenYoungActions.reset,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPreContractualMail: preContractualMailActions.sendPackOpenYoungPreContractualMail,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setAllAccountsToInactive: hirePackOpenYoungActions.setAllAccountsToInactive,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hirePackOpenYoungActions.setVisibleStep,
        setWillCancel: hirePackOpenYoungActions.setWillCancel,
        validate: hirePackOpenYoungActions.validate,
        validateStep: hirePackOpenYoungActions.validateStep,
    }
)(withRouter(HirePackOpenYoungView));
